import { publicDeployTestUrl, publicInternalTestUrl } from './hosts';

export type DeployProgramId = 'beta' | 'internal';

export interface DeployProgram {
  id: DeployProgramId;
  track: 'beta' | 'internal';
  testsApi: string;
  reportsApi: string;
  listPath: string;
  testPath: (id: string) => string;
  resultsPath: (id: string) => string;
  resultsReportPath: (testId: string, reportId: string) => string;
  publicTestHref: (test: { slug?: string; name: string }) => string;
  testProgressLabel: (completed: number, total: number) => string;
  testerFinishedLabel: (completed: number, total: number) => string;
  firmwareNotReady: string;
  startBlockedTitle: string;
  iconClass: string;
  brand: string;
  takeKicker: string;
}

export const BETA_PROGRAM: DeployProgram = {
  id: 'beta',
  track: 'beta',
  testsApi: '/deploy-tests',
  reportsApi: '/beta-test-reports',
  listPath: '/deploy/beta',
  testPath: (id) => `/deploy/beta/tests/${id}`,
  resultsPath: (id) => `/deploy/beta/tests/${id}/results`,
  resultsReportPath: (testId, reportId) => `/deploy/beta/tests/${testId}/results/${reportId}`,
  publicTestHref: publicDeployTestUrl,
  testProgressLabel: (completed, total) =>
    `${completed} of ${total} tests completed`,
  testerFinishedLabel: (completed, total) =>
    `${completed} of ${total} testers completed testing`,
  firmwareNotReady: 'Firmware has not been promoted to beta',
  startBlockedTitle: 'Promote this firmware to beta before starting the test.',
  iconClass: 'text-primary',
  brand: 'Fluora Beta',
  takeKicker: 'Beta Test',
};

export const INTERNAL_PROGRAM: DeployProgram = {
  id: 'internal',
  track: 'internal',
  testsApi: '/internal-tests',
  reportsApi: '/internal-test-reports',
  listPath: '/deploy/internal',
  testPath: (id) => `/deploy/internal/tests/${id}`,
  resultsPath: (id) => `/deploy/internal/tests/${id}/results`,
  resultsReportPath: (testId, reportId) => `/deploy/internal/tests/${testId}/results/${reportId}`,
  publicTestHref: publicInternalTestUrl,
  testProgressLabel: (completed, total) =>
    `${completed} of ${total} tests completed`,
  testerFinishedLabel: (completed, total) =>
    `${completed} of ${total} testers completed testing`,
  firmwareNotReady: 'Firmware has not been published as dev or alpha',
  startBlockedTitle: 'Publish this firmware as dev or alpha before starting the test.',
  iconClass: 'text-warning',
  brand: 'Internal Testing',
  takeKicker: 'Internal Test',
};

